import { render, staticRenderFns } from "./AutomatizadorTarefas.vue?vue&type=template&id=eeaca980"
import script from "./AutomatizadorTarefas.vue?vue&type=script&lang=js"
export * from "./AutomatizadorTarefas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports